/* YAMIWARD — RESIDENT HUB (住民ハブ) + WARD SEALS (印).
   The personalized layer: identity (Shopify customer if signed in, device
   resident otherwise), bloodline status, clan-war standing, digital shelf,
   and the Ward Mint — deterministic generative seal collectibles.

   Seals are closed-loop collectibles: minted free (one per season) for
   verified bloodlines, gifted via one-time codes, never sold or cashed out.
   Art is drawn 100% from code (canvas never taints; downloads always work).
   Provenance lives on the board backend (HMAC-signed, publicly verifiable). */
(function () {
    'use strict';

    var BOARD_API = 'https://api.yamiward.com';
    var REG_KEY = 'yw_resident_registered';

    function el(tag, cls, text) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (text) e.textContent = text;
        return e;
    }

    // Identity is issued and signed by the Ward Board — see identity.js.
    function getUid() {
        var id = window.YW_ID && YW_ID.get();
        return id ? id.uid : '';
    }

    function getClan() {
        try {
            var saved = JSON.parse(localStorage.getItem('yw_clan') || 'null');
            if (!saved || !window.YW_CLANS) return null;
            for (var i = 0; i < window.YW_CLANS.list.length; i++) {
                if (window.YW_CLANS.list[i].key === saved.key) {
                    return { clan: window.YW_CLANS.list[i], seq: saved.seq };
                }
            }
        } catch (e) { }
        return null;
    }

    function hash(str) {
        var h = 5381;
        for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
        return h;
    }

    /* ---- deterministic seal art -------------------------------------------- */
    var VARIANT_META = {
        standard: { label: 'STANDARD ISSUE', bg: '#060609', ring: null },
        night: { label: 'NIGHT ISSUE 百鬼夜行', bg: '#0A0614', ring: '#9B7BD8' },
        gilded: { label: 'GILDED — 1 IN 100', bg: '#0B0906', ring: '#D8B45A' }
    };

    function drawSeal(canvas, clan, serial, variant, season) {
        var W = 1080, H = 1080;
        canvas.width = W; canvas.height = H;
        var ctx = canvas.getContext('2d');
        var meta = VARIANT_META[variant] || VARIANT_META.standard;
        var accent = meta.ring || clan.color;
        var h = hash(serial + '|' + clan.key + '|' + variant);

        ctx.fillStyle = meta.bg;
        ctx.fillRect(0, 0, W, H);

        // radial glow
        var g = ctx.createRadialGradient(W / 2, H / 2, 60, W / 2, H / 2, W * 0.7);
        g.addColorStop(0, accent + '30');
        g.addColorStop(1, 'transparent');
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, W, H);

        // faint scanlines
        ctx.fillStyle = 'rgba(255,255,255,0.02)';
        for (var y = 0; y < H; y += 6) ctx.fillRect(0, y, W, 2);

        var cx = W / 2, cy = H / 2 - 30, R = 330;

        // orbit rings — count + radii + dash from hash (each seal unique)
        var orbits = 2 + (h % 3);
        for (var o = 0; o < orbits; o++) {
            var or = R * (1.12 + 0.14 * o) + ((h >> (o * 4)) % 20);
            ctx.strokeStyle = accent + '2A';
            ctx.lineWidth = 2;
            ctx.setLineDash([8 + ((h >> o) % 30), 14 + ((h >> (o + 2)) % 22)]);
            ctx.beginPath();
            ctx.arc(cx, cy, or, 0, Math.PI * 2);
            ctx.stroke();
            // orbiting particle
            var pa = ((h >> (o * 5)) % 360) * Math.PI / 180;
            ctx.setLineDash([]);
            ctx.fillStyle = accent;
            ctx.beginPath();
            ctx.arc(cx + Math.cos(pa) * or, cy + Math.sin(pa) * or, 6, 0, Math.PI * 2);
            ctx.fill();
        }
        ctx.setLineDash([]);

        // main double ring
        ctx.strokeStyle = accent;
        ctx.lineWidth = 5;
        ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.stroke();
        ctx.lineWidth = 2;
        ctx.beginPath(); ctx.arc(cx, cy, R * 0.92, 0, Math.PI * 2); ctx.stroke();
        if (variant === 'gilded') {
            ctx.lineWidth = 2;
            ctx.beginPath(); ctx.arc(cx, cy, R * 1.05, 0, Math.PI * 2); ctx.stroke();
        }

        // 12 month ticks, the clan's month lit
        for (var i = 0; i < 12; i++) {
            var a = (i / 12) * Math.PI * 2 - Math.PI / 2;
            var active = (i === clan.month - 1);
            ctx.strokeStyle = active ? clan.color : 'rgba(255,255,255,0.22)';
            ctx.lineWidth = active ? 8 : 3;
            ctx.beginPath();
            ctx.moveTo(cx + Math.cos(a) * R * 0.80, cy + Math.sin(a) * R * 0.80);
            ctx.lineTo(cx + Math.cos(a) * R * 0.88, cy + Math.sin(a) * R * 0.88);
            ctx.stroke();
            if (active) {
                ctx.fillStyle = clan.color;
                ctx.beginPath();
                ctx.arc(cx + Math.cos(a) * R * 0.96, cy + Math.sin(a) * R * 0.96, 10, 0, Math.PI * 2);
                ctx.fill();
            }
        }

        // clan kanji core (shrink to fit)
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = clan.color;
        var kSize = 300;
        ctx.font = '900 ' + kSize + 'px "Noto Sans JP", sans-serif';
        while (ctx.measureText(clan.kanji).width > R * 1.15 && kSize > 40) {
            kSize *= 0.92;
            ctx.font = '900 ' + kSize + 'px "Noto Sans JP", sans-serif';
        }
        ctx.fillText(clan.kanji, cx, cy);

        // header
        ctx.fillStyle = 'rgba(255,255,255,0.9)';
        ctx.font = '900 44px Outfit, sans-serif';
        ctx.fillText('YAMIWARD', cx, 84);
        ctx.fillStyle = accent;
        ctx.font = '600 26px "Space Mono", monospace';
        ctx.fillText('WARD SEAL 印 · ' + meta.label, cx, 132);

        // footer block
        ctx.fillStyle = 'rgba(255,255,255,0.92)';
        ctx.font = '900 52px Outfit, sans-serif';
        ctx.fillText(clan.name + ' ' + clan.kanji, cx, H - 200);
        ctx.fillStyle = 'rgba(255,255,255,0.55)';
        ctx.font = '600 30px "Space Mono", monospace';
        ctx.fillText('SEAL No. ' + String(serial).padStart(5, '0') + ' · ' + season, cx, H - 148);

        // deterministic barcode
        var bx = cx - 210, bw = 420;
        ctx.fillStyle = 'rgba(255,255,255,0.5)';
        var x = bx;
        var bh2 = hash(serial + clan.key);
        while (x < bx + bw) {
            var w = 2 + (bh2 % 7); bh2 = (bh2 * 31 + 7) >>> 0;
            if (bh2 % 3) ctx.fillRect(x, H - 108, w, 44);
            x += w + 3;
        }
        return canvas;
    }

    /* ---- hub rendering ------------------------------------------------------ */
    document.addEventListener('DOMContentLoaded', function () {
        var body = document.getElementById('hub-body');
        var root = document.getElementById('hub');
        if (!body || !root || !window.YW_CLANS) return;

        var customer = {
            id: root.getAttribute('data-customer-id') || '',
            email: root.getAttribute('data-customer-email') || '',
            name: root.getAttribute('data-customer-name') || '',
            tags: (root.getAttribute('data-customer-tags') || '').split(',')
        };
        var signedIn = !!customer.id;
        var registered = signedIn || (window.YW_STORE && YW_STORE.get(REG_KEY)) === '1';
        if (signedIn) window.YW_STORE && YW_STORE.set(REG_KEY, '1'); // account > device gate
        var mine = getClan();

        /* identity strip */
        var idBox = el('div', 'hub-card hub-identity');
        idBox.appendChild(el('div', 'hub-card-kicker', 'RESIDENT STATUS 住民'));
        if (signedIn) {
            idBox.appendChild(el('div', 'hub-id-line', (customer.name ? customer.name + ' · ' : '') + customer.email));
            idBox.appendChild(el('div', 'hub-id-status hub-id-verified', '✓ VERIFIED RESIDENT — signed in'));
        } else if (registered) {
            idBox.appendChild(el('div', 'hub-id-status hub-id-verified', '✓ REGISTERED (this device)'));
            idBox.appendChild(el('div', 'hub-id-line', 'Sign in to keep your bloodline, seals and permit on every device.'));
        } else {
            idBox.appendChild(el('div', 'hub-id-status', 'UNREGISTERED SPIRIT'));
            idBox.appendChild(el('div', 'hub-id-line', 'Join the Ward list to unlock the vault, the mint and your permit.'));
        }
        var idBtns = el('div', 'hub-btn-row');
        var login = el('a', 'btn btn-primary hub-btn', signedIn ? 'ORDERS & ACCOUNT' : 'SIGN IN / CREATE ACCOUNT');
        login.href = signedIn ? '/account' : '/account/login';
        idBtns.appendChild(login);
        if (!registered) {
            var reg = el('a', 'btn hub-btn hub-btn-ghost', 'JOIN THE WARD LIST');
            reg.href = '#signup';
            idBtns.appendChild(reg);
        }
        idBox.appendChild(idBtns);
        body.appendChild(idBox);

        /* bloodline strip */
        var clanBox = el('div', 'hub-card');
        clanBox.appendChild(el('div', 'hub-card-kicker', 'YOUR BLOODLINE 血統'));
        if (mine) {
            clanBox.style.setProperty('--hub-accent', mine.clan.color);
            var row = el('div', 'hub-clan-row');
            row.appendChild(el('span', 'hub-clan-kanji', mine.clan.kanji));
            var meta = el('div', 'hub-clan-meta');
            meta.appendChild(el('div', 'hub-clan-name', mine.clan.name));
            meta.appendChild(el('div', 'hub-clan-seq', 'Registry No. ' + String(mine.seq).padStart(4, '0')));
            row.appendChild(meta);
            clanBox.appendChild(row);
            var war = el('div', 'hub-war-line', 'Consulting the war table…');
            clanBox.appendChild(war);
            fetch(BOARD_API + '/api/war/standings')
                .then(function (r) { return r.json(); })
                .then(function (d) {
                    var order = Object.keys(d.en).sort(function (a, b) { return d.en[b] - d.en[a]; });
                    var rank = order.indexOf(mine.clan.key) + 1;
                    war.textContent = 'Clan war ' + d.season + ': ' + (d.en[mine.clan.key] || 0) + ' EN · rank ' + rank + '/12 · season ends ' + d.ends;
                })
                .catch(function () { war.textContent = 'The war table is quiet right now.'; });
        } else {
            clanBox.appendChild(el('div', 'hub-id-line', 'Your birth month already decided this. Make it official.'));
            var verify = el('a', 'btn btn-primary hub-btn', 'VERIFY YOUR BLOODLINE');
            verify.href = '#bloodlines';
            clanBox.appendChild(verify);
        }
        body.appendChild(clanBox);

        /* ---- Ward Ledger — server-side player dashboard via Shopify app proxy.
           Same-origin /apps/ward/* calls are signed by Shopify and carry the
           logged-in customer id; the board answers only for that customer.
           404/503 = proxy not configured yet — the card silently stays hidden. */
        if (signedIn) {
            var ledgerBox = el('div', 'hub-card hub-ledger');
            ledgerBox.appendChild(el('div', 'hub-card-kicker', 'WARD LEDGER 台帳'));
            var ledgerBody = el('div', 'hub-id-line', 'Opening your file…');
            ledgerBox.appendChild(ledgerBody);
            body.appendChild(ledgerBox);

            var KIND_LABEL = { order: 'Order', register: 'Bloodline registration', summon: 'Daily Summon', score: 'Arcade', seal: 'Seal mint', arena_win: 'Arena win', arena_rival: 'Rival defeated' };
            var renderLedger = function (d) {
                ledgerBody.textContent = '';
                ledgerBody.appendChild(el('div', 'hub-clan-name', ((d.en && d.en.earned) || 0) + ' EN earned all-time'));
                var bits = [];
                if (d.bloodline) bits.push(d.bloodline.clan.toUpperCase() + ' bloodline No. ' + String(d.bloodline.seq).padStart(4, '0'));
                bits.push((d.summonDays || 0) + ' summon' + (d.summonDays === 1 ? '' : 's'));
                if (d.arena && (d.arena.wins + d.arena.losses + d.arena.draws) > 0) bits.push('arena ' + d.arena.wins + 'W-' + d.arena.losses + 'L · ' + d.arena.elo + ' elo');
                if (d.seals && d.seals.length) bits.push(d.seals.length + ' seal' + (d.seals.length === 1 ? '' : 's'));
                var facts = el('div', 'hub-id-line', bits.join(' · '));
                ledgerBody.appendChild(facts);
                ((d.en && d.en.ledger) || []).slice(0, 6).forEach(function (e) {
                    var row = el('div', 'hub-ledger-row', '+' + e.points + ' EN · ' + (KIND_LABEL[e.kind] || e.kind) + ' · ' + String(e.created_at).slice(0, 10));
                    row.style.cssText = 'font-family:"Space Mono",monospace;font-size:11px;opacity:.7;margin-top:4px;';
                    ledgerBody.appendChild(row);
                });
                var exp = el('a', '', 'Download my data (JSON)');
                exp.href = '/apps/ward/export';
                exp.style.cssText = 'display:inline-block;margin-top:10px;font-size:12px;opacity:.65;text-decoration:underline;color:inherit;';
                ledgerBody.appendChild(exp);
            };

            var wardMe = function () {
                return fetch('/apps/ward/me').then(function (r) {
                    if (r.status === 404 || r.status === 503) throw new Error('ward-off');
                    return r.json();
                });
            };
            var wardLink = function (payload) {
                return fetch('/apps/ward/link', {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                }).then(function (r) { return r.json(); });
            };
            wardMe().then(function (d) {
                if (d.linked) return d;
                // First visit signed in: adopt this device's history into the account.
                // The token proves this device really owns that history; without it the
                // Board issues a fresh identity rather than handing over someone else's.
                return YW_ID.ready.then(function (id) {
                    return wardLink(id ? { uid: id.uid, token: id.token } : {});
                }).then(function (l) {
                    // The account may already hold a different identity — keep the
                    // Board's answer, it is the authority on who this customer is.
                    if (l && l.uid && l.token) YW_ID.adopt(l.uid, l.token);
                    return wardMe();
                });
            }).then(renderLedger).catch(function (e) {
                if (e && e.message === 'ward-off') { ledgerBox.remove(); return; }
                ledgerBody.textContent = 'The Records Office is not answering. Your file is safe — try again later.';
            });
        }

        /* digital shelf */
        var shelf = el('div', 'hub-card');
        shelf.appendChild(el('div', 'hub-card-kicker', 'DIGITAL SHELF 書棚'));
        var shelfGrid = el('div', 'hub-shelf');
        [['#vault', 'Wallpaper Vault', 'Clan + codex wallpapers'],
        ['#chapters', 'Ward Files', 'The manga, free'],
        ['#resident', 'Resident Permit', 'Your ID card'],
        ['#quiz', 'Ward Diagnosis', 'What haunts you?']].forEach(function (it) {
            var a = el('a', 'hub-shelf-item');
            a.href = it[0];
            a.appendChild(el('div', 'hub-shelf-title', it[1]));
            a.appendChild(el('div', 'hub-shelf-sub', it[2]));
            shelfGrid.appendChild(a);
        });
        shelf.appendChild(shelfGrid);
        body.appendChild(shelf);

        /* ---- the Ward Mint ---- */
        var mintBox = el('div', 'hub-card hub-mint');
        mintBox.appendChild(el('div', 'hub-card-kicker', 'THE WARD MINT 印'));
        mintBox.appendChild(el('div', 'hub-id-line',
            'One seal per resident per season — a one-of-one mark of your bloodline, numbered by the Registry. ' +
            'Night mints come out different. Every 100th seal is gilded. Seals can be gifted, never sold.'));
        var album = el('div', 'hub-seal-album');
        var mintRow = el('div', 'hub-btn-row');
        var mintBtn = el('button', 'btn btn-primary hub-btn', 'MINT MY SEAL');
        var mintMsg = el('div', 'hub-mint-msg');
        mintRow.appendChild(mintBtn);
        mintBox.appendChild(mintRow);
        mintBox.appendChild(mintMsg);
        mintBox.appendChild(album);

        function sealCard(s) {
            var clanObj = null;
            for (var i = 0; i < window.YW_CLANS.list.length; i++) {
                if (window.YW_CLANS.list[i].key === s.clan) clanObj = window.YW_CLANS.list[i];
            }
            if (!clanObj) return null;
            var card = el('div', 'hub-seal-card');
            card.style.setProperty('--hub-accent', (VARIANT_META[s.variant] && VARIANT_META[s.variant].ring) || clanObj.color);
            var cv = document.createElement('canvas');
            cv.className = 'hub-seal-canvas';
            document.fonts.ready.then(function () { drawSeal(cv, clanObj, s.serial, s.variant, s.season); });
            card.appendChild(cv);
            card.appendChild(el('div', 'hub-seal-label', 'No. ' + String(s.serial).padStart(5, '0') + ' · ' + (VARIANT_META[s.variant] ? VARIANT_META[s.variant].label : s.variant)));
            var btns = el('div', 'hub-btn-row');
            var dl = el('button', 'btn hub-btn hub-btn-ghost', 'DOWNLOAD');
            dl.addEventListener('click', function () {
                var a = document.createElement('a');
                a.download = 'yamiward-seal-' + s.serial + '-' + s.clan + '.png';
                a.href = cv.toDataURL('image/png');
                a.click();
            });
            var gift = el('button', 'btn hub-btn hub-btn-ghost', 'GIFT');
            gift.addEventListener('click', function () {
                gift.disabled = true;
                // YW_ID.post carries uid AND token; the server now refuses a
                // gift that names a uid without its signature (2026-09-24).
                YW_ID.post(BOARD_API + '/api/seals/gift', { serial: s.serial })
                .then(function (r) { return r.json(); }).then(function (d) {
                    gift.disabled = false;
                    if (d.code) {
                        mintMsg.textContent = 'Gift code for seal ' + s.serial + ': ' + d.code + ' — send it to another resident. One use; the seal leaves your album when claimed.';
                    } else mintMsg.textContent = d.error || 'The Mint refused.';
                }).catch(function () { gift.disabled = false; mintMsg.textContent = 'The Mint is unreachable.'; });
            });
            btns.appendChild(dl);
            btns.appendChild(gift);
            card.appendChild(btns);
            return card;
        }

        function loadAlbum() {
            fetch(BOARD_API + '/api/seals/mine?uid=' + encodeURIComponent(getUid()))
                .then(function (r) { return r.json(); })
                .then(function (d) {
                    album.textContent = '';
                    (d.seals || []).forEach(function (s) {
                        var c = sealCard(s);
                        if (c) album.appendChild(c);
                    });
                    if (d.seals && d.seals.length) mintBtn.textContent = 'SEAL MINTED THIS SEASON ✓';
                })
                .catch(function () { });
        }

        mintBtn.addEventListener('click', function () {
            if (!registered) { location.hash = '#signup'; return; }
            if (!mine) { location.hash = '#bloodlines'; mintMsg.textContent = 'Verify your bloodline first — the Mint stamps clans, not strangers.'; return; }
            mintBtn.disabled = true;
            fetch(BOARD_API + '/api/seals/mint', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ uid: getUid() })
            }).then(function (r) { return r.json(); }).then(function (d) {
                mintBtn.disabled = false;
                if (d.seal) {
                    mintMsg.textContent = d.already ? 'Your seal for this season already exists.' :
                        'Minted: seal No. ' + d.seal.serial + (d.seal.variant !== 'standard' ? ' — ' + VARIANT_META[d.seal.variant].label : '') + '. It is one of one.';
                    loadAlbum();
                } else mintMsg.textContent = d.error || 'The Mint refused.';
            }).catch(function () { mintBtn.disabled = false; mintMsg.textContent = 'The Mint is unreachable.'; });
        });

        /* claim + verify row */
        var toolRow = el('div', 'hub-tool-row');
        var claimWrap = el('div', 'hub-tool');
        claimWrap.appendChild(el('div', 'hub-tool-label', 'CLAIM A GIFTED SEAL'));
        var claimInput = document.createElement('input');
        claimInput.className = 'hub-input';
        claimInput.placeholder = 'GIFT CODE';
        claimInput.maxLength = 16;
        var claimBtn = el('button', 'btn hub-btn hub-btn-ghost', 'CLAIM');
        claimBtn.addEventListener('click', function () {
            var code = claimInput.value.trim();
            if (!code) return;
            YW_ID.post(BOARD_API + '/api/seals/claim', { code: code })
            .then(function (r) { return r.json(); }).then(function (d) {
                mintMsg.textContent = d.ok ? 'Seal No. ' + d.seal.serial + ' is now yours.' : (d.error || 'Invalid code.');
                if (d.ok) { claimInput.value = ''; loadAlbum(); }
            }).catch(function () { mintMsg.textContent = 'The Mint is unreachable.'; });
        });
        claimWrap.appendChild(claimInput);
        claimWrap.appendChild(claimBtn);

        var verWrap = el('div', 'hub-tool');
        verWrap.appendChild(el('div', 'hub-tool-label', 'VERIFY ANY SEAL'));
        var verInput = document.createElement('input');
        verInput.className = 'hub-input';
        verInput.placeholder = 'SEAL No.';
        verInput.maxLength = 8;
        var verBtn = el('button', 'btn hub-btn hub-btn-ghost', 'VERIFY');
        verBtn.addEventListener('click', function () {
            var n = parseInt(verInput.value, 10);
            if (!n) return;
            fetch(BOARD_API + '/api/seals/verify/' + n)
                .then(function (r) { return r.json(); })
                .then(function (d) {
                    if (!d.exists) { mintMsg.textContent = 'Seal No. ' + n + ' does not exist. Nothing with that number ever left the Mint.'; return; }
                    mintMsg.textContent = 'Seal No. ' + n + ': ' + d.seal.clan.toUpperCase() + ' · ' + d.seal.variant + ' · ' + d.seal.season +
                        ' · ' + (d.authentic ? 'AUTHENTIC ✓' : 'SIGNATURE MISMATCH ✗') + (d.gifted ? ' · has changed hands' : '');
                })
                .catch(function () { mintMsg.textContent = 'The Mint is unreachable.'; });
        });
        verWrap.appendChild(verInput);
        verWrap.appendChild(verBtn);

        toolRow.appendChild(claimWrap);
        toolRow.appendChild(verWrap);
        mintBox.appendChild(toolRow);
        body.appendChild(mintBox);

        loadAlbum();
    });
})();
